module.exports = __webpack_public_path__ + "static/media/table_column_checkbox.e8f96c75.png";